/**
 * Slug-shaped listing-id patterns for technology types that have no Salesforce record behind them
 * (skills, plugins), plus the id-shape detectors built on them.
 *
 * LEAF MODULE — ZERO IMPORTS, ON PURPOSE. `listingCard.ts` inlines these patterns rather than
 * importing them from `listing_utils.ts` to avoid pulling that module's `listing_service` import
 * chain into the card bundle. Extracting them here (instead of continuing to duplicate them)
 * requires this module to stay import-free, so both `listing_utils.ts` and `listingCard.ts` can
 * depend on it without either paying for the other's dependency graph. Do not add imports here —
 * if a helper needs one, it belongs in `listing_utils.ts` instead.
 */

// Skill listings are identified by a slug-shaped external id (`skill-agentforce-generate`) rather
// than a UUID or SFID, because a skill has no Salesforce record behind it. Length varies with the
// slug (21–49 chars on the live listings), so this is matched by shape, not by length.
export const SKILL_LISTING_ID_PATTERN = /^skill-[a-z0-9]+(?:-[a-z0-9]+)*$/;

// Plugin listings (a bundle of skills) share the same id-shape family as skills: a slug-shaped
// external id (`plugin-agentforce`) rather than a UUID or SFID.
export const PLUGIN_LISTING_ID_PATTERN = /^plugin-[a-z0-9]+(?:-[a-z0-9]+)*$/;

export function isSkillListingId(listingId?: string): boolean {
    return !!listingId && SKILL_LISTING_ID_PATTERN.test(listingId);
}

export function isPluginListingId(listingId?: string): boolean {
    return !!listingId && PLUGIN_LISTING_ID_PATTERN.test(listingId);
}
